import { ChangeDetectorRef, Component, NgZone, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CDS_POPUP_DATA, CdsPopupModule } from '@cds/ng-web-components/popup';
import { DateTime } from 'luxon';
import { AMLCommentHistory } from 'src/app/views/employee/employee';
import { AmlRiskSummaryService } from './aml-risk-summary.service';
import { BasicResponse } from 'src/app/core/models/response/response';
import { LoadingComponent } from '../loading/loading.component';
import { TableExpandComponent } from '../../components/table/table-expand/table-expand.component';
import { TableExpandColComponent } from '../../components/table/table-expand-col/table-expand-col.component';
import { FnPipe } from '../pipe/fn.pipe';
import { CdsLanguageModule } from '@cds/ng-core/lang';
import { finalize, timeout } from 'rxjs';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-aml-comments-history',
  templateUrl: './aml-comments-history.component.html',
  styleUrls: ['./aml-comments-history.component.scss'],
  imports: [CdsPopupModule, LoadingComponent, TableExpandComponent, TableExpandColComponent, FnPipe, CdsLanguageModule, CdsIconModule],
})
export class AmlCommentsHistoryComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<AmlCommentsHistoryComponent>>(MatDialogRef);
  data = inject<{
    customerId: string | undefined;
    entityType: 'EE' | 'ER';
  }>(CDS_POPUP_DATA);
  private service = inject(AmlRiskSummaryService);
  private zone = inject(NgZone, { optional: true }) ?? ({ run: <T>(fn: () => T) => fn() } as NgZone);
  private cdr = inject(ChangeDetectorRef, { optional: true }) ?? ({ detectChanges: () => undefined } as ChangeDetectorRef);

  isLoading = false;

  dataList: AMLCommentHistory[] = [];

  ngOnInit(): void {
    if (this.data.customerId) {
      this.getCommentsHistory(this.data.customerId, this.data.entityType);
    }
  }

  gotIt() {
    this.dialogRef.close({ agree: false });
  }

  getCommentsHistory(customerId: string, entityType: 'EE' | 'ER') {
    this.isLoading = true;
    this.service
      .getCommentHistory(customerId, entityType)
      .pipe(
        timeout(15000),
        finalize(() => {
          this.runInUi(() => {
            this.isLoading = false;
          });
        })
      )
      .subscribe({
        next: (response: BasicResponse<AMLCommentHistory[]>) => {
          this.runInUi(() => {
            if (response.result === 0 && response.data) {
              this.dataList = response.data;
            }
          });
        },
        error: () => {
          this.runInUi(() => {
            this.dataList = [];
          });
        },
      });
  }

  updateDateGen(value: string) {
    const dateTime = DateTime.fromISO(value);
    if (dateTime.isValid) {
      return dateTime.toFormat('hh:mma dd/MM/yyyy (Z') + 'T)';
    }
    return '';
  }

  private runInUi(work: () => void): void {
    this.zone.run(() => {
      work();
      this.safeDetectChanges();
    });
  }

  private safeDetectChanges(): void {
    if (!(this.cdr as ChangeDetectorRef & { destroyed?: boolean }).destroyed) {
      this.cdr.detectChanges();
    }
  }
}
